import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

export type IBrandIcon = React.ComponentType<{
    size: string;
    className?: string;
    wrapperColor?: string;
    wrapperSize?: string;
    wrapperType?: "circle" | "square";
}>;

interface IProps {
    children: React.ReactNode;
    icon: IBrandIcon;
    iconText?: React.ReactNode;
    header?: React.ReactNode;
    headerTag?: Parameters<typeof Text>[0]["as"];
    text?: React.ReactNode;
}

export const ResponsiveCardBodyWithIcon: React.FC<IProps> = ({icon: Icon, iconText, header, headerTag, text, children}) => (
    <div className={wrapperStyle}>
        {(Icon || iconText) && (
            <div className={iconColumnStyle}>
                {Icon && (
                    <div className={iconWrapperStyle}>
                        <Icon size="6.4" wrapperColor="#ebff00" wrapperSize="6.4" wrapperType="circle" className={iconStyle} />
                    </div>
                )}
                <Text as="p" variant="info_txt_1" align="center">
                    {iconText}
                </Text>
            </div>
        )}
        <div className={contentStyle}>
            {header && (
                <Text as={headerTag || "h3"} variant="headline_3" className={headerStyle}>
                    {header}
                </Text>
            )}
            {text && (
                <Text variant="body_copy_1" className={textStyle}>
                    {text}
                </Text>
            )}
            {children}
        </div>
    </div>
);

const wrapperStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    padding: 2,
    md: {
        alignItems: "center"
    }
});

const iconColumnStyle = css({
    paddingLeft: 2,
    paddingRight: 2
});

const iconWrapperStyle = css({
    position: "relative",
    height: "6.4rem",
    width: "6.4rem",
    marginBottom: 1
});

const iconStyle = css({
    left: 0,
    top: 0,
    position: "absolute"
});

const contentStyle = css({
    flex: "1 1",
    paddingLeft: 2,
    paddingRight: 2
});

const headerStyle = css({
    paddingBottom: 1
});

const textStyle = css({
    paddingBottom: 2
});
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

export type IBrandIcon = React.ComponentType<{
    size: string;
    className?: string;
    wrapperColor?: string;
    wrapperSize?: string;
    wrapperType?: "circle" | "square";
}>;

interface IProps {
    children: React.ReactNode;
    icon: IBrandIcon;
    iconText?: React.ReactNode;
    header?: React.ReactNode;
    headerTag?: Parameters<typeof Text>[0]["as"];
    text?: React.ReactNode;
}

export const ResponsiveCardBodyWithIcon: React.FC<IProps> = ({icon: Icon, iconText, header, headerTag, text, children}) => (
    <div className={wrapperStyle}>
        {(Icon || iconText) && (
            <div className={iconColumnStyle}>
                {Icon && (
                    <div className={iconWrapperStyle}>
                        <Icon size="6.4" wrapperColor="#ebff00" wrapperSize="6.4" wrapperType="circle" className={iconStyle} />
                    </div>
                )}
                <Text as="p" variant="info_txt_1" align="center">
                    {iconText}
                </Text>
            </div>
        )}
        <div className={contentStyle}>
            {header && (
                <Text as={headerTag || "h3"} variant="headline_3" className={headerStyle}>
                    {header}
                </Text>
            )}
            {text && (
                <Text variant="body_copy_1" className={textStyle}>
                    {text}
                </Text>
            )}
            {children}
        </div>
    </div>
);

const wrapperStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    padding: 2,
    md: {
        alignItems: "center"
    }
});

const iconColumnStyle = css({
    paddingLeft: 2,
    paddingRight: 2
});

const iconWrapperStyle = css({
    position: "relative",
    height: "6.4rem",
    width: "6.4rem",
    marginBottom: 1
});

const iconStyle = css({
    left: 0,
    top: 0,
    position: "absolute"
});

const contentStyle = css({
    flex: "1 1",
    paddingLeft: 2,
    paddingRight: 2
});

const headerStyle = css({
    paddingBottom: 1
});

const textStyle = css({
    paddingBottom: 2
});
